export default __webpack_public_path__ + "static/media/ach-low-rate.3a7c3268.png";